import React from "react";

import { ReactComponent as Logo } from "../../../../../assets/svg/logo.svg";
import styles from "../HelpEnvironmentSection.module.scss";

const PlaybackCheckPanel = () => {
  return (
    <div className={styles.panel}>
      <p className={styles.panelHeading}>
        表示・再生の確認（通信環境チェック）
      </p>
      <div className={styles.card}>
        <p className={styles.cardHeading}>現在ご利用の端末・ブラウザ環境</p>
        <p className={styles.text}>{navigator.userAgent}</p>
        <p className={styles.note}>
          ※この情報はご利用のブラウザより自動取得されています。
        </p>
      </div>
      <div className={styles.card}>
        <p className={styles.cardHeading}>コンテンツの表示確認</p>
        <p className={styles.text}>
          下にENAGEEDのロゴが表示されていれば、表示環境は正常です。
          <br />
          デジタル教材のご利用には、端末1台あたり「2Mbps程度以上」の通信速度を推奨しています。
        </p>
        <div className={styles.frame}>
          <Logo width={"126px"} height={"22px"} />
        </div>
      </div>
      <div className={styles.card}>
        <p className={styles.cardHeading}>授業用動画の再生確認</p>
        <p className={styles.text}>
          再生ボタンが表示され、動画が再生できれば正常です。
        </p>
        <div className={styles.frame}>
          <iframe
            className={styles.playbackCheckVideo}
            src="https://lounge.enageed.net/movie/sample.html"
            title="授業用動画の再生確認"
            allowFullScreen
          />
        </div>
      </div>
      <p className={styles.text}>
        画像が表示されない、動画が再生できない場合は、推奨環境やネットワーク設定により必要な通信が制限されている可能性があります。
        <br />
        フィルタリングソフト、ファイアウォール、プロキシサーバ等の設定をご確認ください。
      </p>
    </div>
  );
};

export default PlaybackCheckPanel;
